<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-24
    	描述：财务-财务概况
    -->
  <div class="home" v-loading="loading">
    <div class="d-s-c d-r">
      <el-date-picker v-model="datePicker" type="datetimerange" :picker-options="pickerOptions" size="small"
        format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" align="right">
      </el-date-picker>
      <el-button size="small" type="primary" style="margin-left: 10px;" icon="el-icon-search" @click="getData">查询</el-button>
      <el-button size="small" type="warning" @click="dialogVisible = true">下载支付宝账单</el-button>
    </div>
    <div class="cash cash_t_common cash_t_brief">
      <div class="cash-header">
        <div class="show-hide">
          <span class="cash_t_title">平台概况 </span>
          <img :src="show?'./static/imgs/show.png':'./static/imgs/hide.png'" class="icon-img-cash" @click="btnIconShow">
        </div>
      </div>
      <div class="cash-body">
        <div class="cash_item">
          <p class="title">
            <span>总租金（元）</span>
          </p>
          <p class="money">{{ show?rent.totalRent:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">待还租金</p>
          <p class="money">{{ show?rent.rentRepaid:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">逾期率</p>
          <p class="money">{{ show?rent.overdueRate:'*****'}}</p>
        </div>
      </div>
      <div class="cash-body">
        <div class="cash_item">
          <p class="title">已还租金（元）</p>
          <p class="money">{{ show?rent.rentPaid:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">实付金额（元）</p>
          <p class="money">{{ show?rent.advanceRent:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">主动还款（元）</p>
          <p class="money">{{ show?rent.activeRepayment:'*****' }}</p>
        </div>
      </div>
      <div class="cash-body">
        <div class="cash_item">
          <p class="title">买断金额（元）</p>
          <p class="money">{{ show?rent.pendingBuyout:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">逾期金额（元）</p>
          <p class="money">{{ show?rent.yuqiRepayment:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">代扣金额（元）</p>
          <p class="money">{{ show?rent.daikouRepayment:'*****' }}</p>
        </div>
      </div>
      <div class="cash-body">
        <div class="cash_item">
          <p class="title">合同金额（元）</p>
          <p class="money">{{ show?rent.hetong:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">合集进货金额（元）</p>
          <p class="money">{{ show?rent.jinhuo:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">未到期金额（元）</p>
          <p class="money">{{ show?rent.daikouRepayment:'*****' }}</p>
        </div>
      </div>
      <div class="cash-body">
        <div class="cash_item">
          <p class="title">利润（元）</p>
          <p class="money">{{ show?rent.lirun:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">坏账订单数</p>
          <p class="money">{{ show?rent.huaizhang:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">坏账订单率</p>
          <p class="money">{{ show?rent.huaizhangRate:'*****' }}</p>
        </div>
      </div>
      <div class="cash-body">
        <div class="cash_item">
          <p class="title">坏账金额</p>
          <p class="money">{{ show?rent.huaizhangPrice:'*****' }}</p>
        </div>
        <div class="cash_item">
          <p class="title">坏账金额率</p>
          <p class="money">{{ show?rent.huaizhangPriceRate:'*****' }}</p>
        </div>
        <div class="cash_item">
        </div>
      </div>
      <div class="cash-header">
        <div>
          <span class="cash_t_title">投资收益测算表</span>
        </div>
      </div>
      <div class="cash-wrap">
        <div class="cash_item">
          <div class="title">分期数</div>
          <div class="cash_input mt10">
            <el-select style="width: 100%;" size="small" v-model="calculation.periodization">
              <el-option v-for="(item, index) in periodizationOptions" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="cash_item">
          <div class="title">官网金额</div>
          <div class="cash_input mt10">
            <el-input-number v-model="calculation.websiteAmount" controls-position="right" style="width: 100%;" size="small" ></el-input-number>
          </div>
        </div>
        <div class="cash_item">
          <div class="title">应收租金</div>
          <div class="cash_input mt10">
            <el-input-number v-model="calculation.rentReceivable" controls-position="right" style="width: 100%;" size="small" ></el-input-number>
          </div>
        </div>
        <div class="cash_item">
          <div class="title">每期租金</div>
          <div class="money mt10" style="font-size: 20px;">
            {{ calculation.rentPeriod }}
          </div>
        </div>
        <div class="cash_item">
          <div class="title">预收租金</div>
          <div class="cash_input mt10">
            <el-select style="width: 100%;" size="small" v-model="calculation.unearnedRent">
              <el-option v-for="(item, index) in unearnedRentOptions" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="cash_item">
          <div class="title">已缴纳租金</div>
          <div class="money mt10" style="font-size: 20px;">
            {{ calculation.paidRent }}
          </div>
        </div>
        <div class="cash_item">
          <div class="title">未缴纳租金</div>
          <div class="money mt10" style="font-size: 20px;">
            {{ calculation.unpaidRent }}
          </div>
        </div>
      </div>
      <div class="cash-body">
        <div class="cash_item">
          <p class="title">实际投入金额</p>
          <p class="money">
            {{ calculation.websiteAmount }}
          </p>
        </div>
        <div class="cash_item">
          <p class="title">应收总租金</p>
          <p class="money">
            {{ calculation.rentReceivable }}
          </p>
        </div>
        <div class="cash_item">
          <p class="title">资产收益率</p>
          <p class="money">{{ calculation.totalYieldRate }} %</p>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form :model="form" label-width="60px">
        <el-form-item label="账单类型">
          <el-select v-model="form.type" size="small" style="width: 90%;">
            <el-option label="日账单" value="1"></el-option>
            <el-option label="月账单" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账单日期">
          <el-date-picker
            v-if="form.type === '1'"
            v-model="form.date"
            style="width: 90%;"
            size="small"
            type="date"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日"
          />
          <el-date-picker
            v-if="form.type === '2'"
            v-model="form.date"
            style="width: 90%;"
            size="small"
            type="month"
            format="yyyy年MM月"
            value-format="yyyy-MM"
            placeholder="选择月"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="getBill" size="small">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import CashApi from '@/api/cash.js';
import IndexApi from "@/api/index.js";
import useApi from "@/api/useApi.js";
import { formatDate } from '@/utils/DateTime.js'
import pieChart from "@/views/home/part/product/pieChart.vue";  //引入组件
export default {
  data() {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
    return {
      show:false,
      /*对话框*/
      dialogVisible: false,
      form: {
        type: "1",
        date: ""
      },
      /*是否加载完成*/
      loading: true,
      /*统计数据*/
      tj_data: {},
      /*供应商数据*/
      supplier_data: {},
      /*分销商数据*/
      agent_data: {},
      rent: "",
      starttime: '',
      endtime: '',
      //时间
      pickerOptions: {
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
      datePicker: [formatDate(startDate, 'yyyy-MM-dd 00:00:00'), formatDate(endDate, 'yyyy-MM-dd 23:59:59')],
      periodizationOptions: [
        { label: '请选择', value: undefined },
        { label: '6期', value: 6 },
        { label: '8期', value: 8 },
        { label: '12期', value: 12 }
      ],
      unearnedRentOptions: [
        { label: '请选择', value: undefined },
        { label: '1期', value: 1 },
        { label: '2期', value: 2 },
        { label: '3期', value: 3 },
        { label: '4期', value: 4 },
        { label: '5期', value: 5 },
        { label: '6期', value: 6 },
        { label: '7期', value: 7 },
        { label: '8期', value: 8 },
        { label: '9期', value: 9 },
        { label: '10期', value: 10 },
        { label: '11期', value: 11 },
        { label: '12期', value: 12 }
      ],
      calculation: {
        periodization:  /*测算表*/      undefined,
        websiteAmount:  /*官网金额*/    0,
        rentReceivable: /*应收租金*/    0,
        rentPeriod:     /*每期租金*/    0,
        unearnedRent:   /*预收租金*/    undefined,
        paidRent:       /*已缴纳租金*/  null,
        unpaidRent:     /*未缴纳租金*/  null,
        totalYieldRate: /*资产收益率*/  null,
      },
    };
  },
  computed: {
    yieldRate: function() {
      const result = (
        this.calculation.rentReceivable
          / this.calculation.websiteAmount * 100 - 100
      ).toFixed(2);

      if (!isFinite(result)) return '0.00';
      return result;
    },
    rentPeriodMoney: function() {
      if (
        !this.calculation.periodization ||
        !this.calculation.periodization
      ) return;
      return (
        this.calculation.rentReceivable
          / this.calculation.periodization
      ).toFixed(2);
    }
  },
  watch: {
    'rentPeriodMoney': function(newVal, oldVal) {
      console.log(newVal, "-----> rentPeriod")
      if (!newVal) return;
      this.calculation.rentPeriod = newVal;
    },
    'calculation.unearnedRent': function(newVal, oldVal) {
      const tar = this.calculation;
      tar.paidRent = (tar.rentPeriod * newVal).toFixed(2);
      tar.rentReceivable && (tar.unpaidRent = (tar.rentReceivable - tar.paidRent).toFixed(2));
    },
    'yieldRate': function(newVal) { this.calculation.totalYieldRate = newVal; }
  },
  created() {
    /*获取数据*/
    this.getData();
  },
  components: {
    pieChart
  },
  methods: {
    // 是否显示数据
    btnIconShow(){
      this.show = !this.show
    },

    /*下载账单*/
    getBill: async function() {
      const { msg, data } = await useApi().aliPayBill(this.form);
      this.$message.success(msg);
      const a = document.createElement('a');
      a.href = data.bill_url;
      a.click();
      a.remove();
      dialogVisible.value = false;
    },
    /*获取数据*/
    getData() {
      let self = this;
      self.loading = true;
      self.starttime = self.datePicker[0];
      self.endtime = self.datePicker[1];

      let shju = {
        startTime: self.starttime,
        endTime: self.endtime,
      };
      IndexApi.dataCenter(shju, true)
        .then((data) => {
          console.log(data.data.data);
          self.rent = data.data.data.rent;
          self.$message({
            message: "加载成功",
            type: 'success'
          })
          self.loading = false;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
  }
};
</script>

<style lang="scss" scoped>
  .show-hide {
     display: flex;
     align-items: center;
  }

  .icon-img-cash {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }


.apply-container {
  padding: 50px 0;
}

.cash {
  background-color: #fff;
  font: 14px;
}

.cash_t_common {
  margin-top: 15px;
  margin-bottom: 0;
  box-shadow: initial;

  .cash_t_title {
    font-size: 16px;
    font-weight: 600;
  }

  .cash-header {
    padding: 5px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.cash_t_brief .cash-header {
  border-bottom: 0;
}

.cash-header {
  position: relative;
  height: 42px;
  line-height: 42px;
  padding: 0 15px;
  border-bottom: 1px solid #f6f6f6;
  color: #333;
  border-radius: 2px 2px 0 0;
  font-size: 14px;
}

.cash_t_brief .cash_t_title {
  position: relative;
  padding-left: 10px;
}

.cash_t_brief .cash_t_title::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 14px;
  background-color: #3a8ee6;
  position: absolute;
  left: 0;
  top: 50%;
  border-radius: 5px;
  transform: translateY(-50%);
}

.cash_t_common .cash-body {
  padding: 20px;
}

.cash-wrap {
  margin: 0 15px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  align-items: center;

  .cash_item {
    width: 150px;
    height: 90px;
    padding: 15px;
    border-radius: 8px;
    margin: 10px;
    border: 1px solid #a7a7a7;
  }
}

.cash-body {
  display: flex;
  min-width: 1000px;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
  margin: 10px 15px;
  line-height: 24px;
  background-color: #f5f6f8;

  .cash_item {
    min-width: 250px;
    max-width: 360px;
    width: 33.33%;
    padding: 8px 25px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    // margin-bottom: 20px;
    justify-content: center;
    color: #333;

    .title {
      border-bottom: 1px solid #ccc;
    }
  }

  .content {
    width: 33.3%;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    justify-content: center;
  }

  .money {
    font-size: 20px;
    color: #797979;
    font-weight: bold;
    margin-top: 10px;
    max-width: 250px;
  }

  .subhead {
    font-size: 12px;
    margin-left: 3px;
    cursor: pointer;
  }
}

.cash_bg_red {
  background-color: #ffe9e9;
}

.cash_bg_blue {
  background-color: #d3f1ff;
}

.cash_bg_yellow {
  background-color: #fff3d1;
}

.cash_bg_purple {
  background-color: #dacbeb;
}

.cash_bg_green {
  background-color: #e4ffed;
}

.cash_bg_gold {
  background-color: #fffae4;
}

.cash_bg_lavender {
  background-color: #fffae4;
}

.cash_bg_pale {
  background-color: #fff4e4;
}

.ns-text-color {
  color: #3a8ee6;
}

.date_section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/cash/cash/index.vue